import { gql } from '@apollo/client';

import { Assignment } from '../../types';
import { assignmentFragment } from '../fragments';

export interface SendAssignmentMutationVariables {
  courseId: string;
  assignmentId: string;
}

export interface SendAssignmentMutationResult {
  assignment: Assignment;
}

export const sendAssignmentMutation = gql`
  mutation SendAssignmentMutation($courseId: String!, $assignmentId: String!) {
    assignment(courseId: $courseId, assignmentId: $assignmentId, input: {})
      @rest(type: "Assignment", path: "courses/{args.courseId}/assignments/{args.assignmentId}/send", method: "PUT") {
      ...Assignment
    }
  }
  ${assignmentFragment}
`;
